import 'virtual:uno.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { useAuthStore } from './stores/auth'
import permissionDirective from './directives/permission'
import { VueQueryPlugin, vueQueryOptions } from '@/plugins/vue-query'
import { installWorkflowEditorHost } from '@/plugins/workflow-editor-host'
import { MotionPlugin } from '@vueuse/motion'
// 引入 RemixIcon 图标字体（从 node_modules 直接导入）
import 'remixicon/fonts/remixicon.css'
// Element Plus CSS 已移除 — 全部迁移到 Arco Design（Task 13 v1.0.6）
import './styles/main.scss'
// AI-Native UI design tokens（路径 C 接线后视觉升级 - 2026-04-22）
import './styles/ai-tokens.css'
// Claude Code 素色主题（2026-04-29）—— 必须在 ai-tokens 之后 import，确保 cascade 覆盖
import './styles/claude-tokens.css'
import './styles/wangshu/tokens.css'
import './styles/wangshu/theme.css'
import './styles/wangshu/shell.css'
import './styles/wangshu/components/instance.css'
import './styles/wangshu/components/workbench.css'
// wangshu × claude 统一设计系统（全站复用 · scoped 经 data-ds="wangshu" 启用，2026-06-11）
// 必须最后 import：作用域 token 需覆盖 claude-tokens / commercial-tokens / wangshu 全局定义
import './styles/design-system.css'

// 注册 Claude 素色 ECharts 全局主题（任何图表通过 :theme="'claude-mono'" 引用即可）
import { registerClaudeTheme } from '@/components/charts/registerTheme'
registerClaudeTheme()

// Sentry 前端监控（VITE_SENTRY_DSN 缺失时 no-op，本地默认禁用）
import { initSentry } from './observability/sentry'

// 启动时一次性清理 localStorage 中被毒化的非法 projectId（如手敲 ?project_id=p131-verify 残留），
// 否则坏值会卡死整个会话所有依赖 RLS 的 API。必须在 Pinia / 业务 store 初始化前运行。
import { sweepInvalidIdentityStorage } from './utils'
sweepInvalidIdentityStorage()

const app = createApp(App)
initSentry(app)

// 工作流编辑器包的宿主能力装配（HTTP / SSE / 鉴权 / 模型目录 / MCP / 文件 / 知识库）
installWorkflowEditorHost()

const pinia = createPinia()
app.use(pinia)
app.use(VueQueryPlugin, vueQueryOptions)
app.use(i18n)
app.use(router)
app.use(MotionPlugin)
app.directive('permission', permissionDirective)

// 初始化认证状态
const authStore = useAuthStore()
authStore.initAuth()

// 初始化主题（claude / white / dark），从 localStorage 读取，默认 claude
import { useThemeStore } from './stores/theme'
const themeStore = useThemeStore()
themeStore.initTheme()

app.mount('#app')
